import styled from "styled-components";
import { theme } from "@themes";

export const MyCalendar = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
`;

export const MyCalendarContent = styled.div`
  height: 86vh;
  display: grid;
  grid-template-columns: 60% 40%;
  grid-gap: 1em;
  padding: 1em;
  background: ${({ theme }) => theme.neutral.white};
  .liveContent {
    box-shadow: 0px 2px 8px rgb(0 0 0 / 10%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .liveContent .MuiTabs-root {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .liveContent .tabpanel {
    text-align: center;
  }
  .MuiTab-wrapper {
    color: ${({ theme }) => theme.neutral.white} !important;
    font-weight: 700 !important;
  }
  .MuiTabs-indicator {
    display: none;
  }
`;
export const LiveEvent = styled.div`
  box-shadow: 3px 4px 3px 0px rgb(225 225 225 / 50%),
    0 0px 20px 0px rgb(225 225 225 / 80%);
  display: grid;
  grid-template-columns: 1fr 34px;
  padding: 6px;
  border-radius: 5px;
  width: 16vw;
  margin-left: 12px;
  height: 8em;
  .view-event-btn {
    background-color: ${({ theme }) => theme.button.primary};
    border: none;
    outline: none;
  }
  .view-event-btn svg {
    fill: ${({ theme }) => theme.neutral.white} !important;
    cursor: pointer;
    width: 22px;
    height: 20px;
    padding-left: 7px;
  }
`;
export const EventDetail = styled.div`
  display: inline-grid;
  label {
    font-weight: 700;
  }
  svg {
    margin-right: 5px;
    font-size: 18px;
  }
  span {
    margin-bottom: 5px;
  }
`;
export const ContentLives = styled.div`
  display: grid;
  grid-gap: 1em;
  max-height: 72.9vh;
  overflow-y: auto;
  padding: 3px 0 10px 0;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
export const MessageNoEvents = styled.div`
  color: purple;
  margin: auto;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;

export const RightSection = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`;
